require('sma.fs/sass/editor.sass');
require('sma.fs/surveys/jSignature.min.css');

require('codemirror/lib/codemirror.css');
require('codemirror/theme/monokai.css');

module.exports = {
	Editor: require('sma.fs/surveys/editor').Editor,
};
